import request from '@/natives/libs/request';

export default {
  getELearnginSign() {
    return request.get(`/hpp/company/hik_id/v1/sign`, null, { hasErrorHandle: false });
  }
};
